import React from 'react';
import { LoaderButton } from 'components/common/LoadingButton';

interface PmoModalActionsProps {
  onCancel: () => void;
  onConfirm: () => void;
  confirmText: string;
  /** `danger` for an action that destroys something, in the designs' red. */
  variant?: 'primary' | 'danger';
  disabled?: boolean;
  isLoading?: boolean;
}

/**
 * Cancel + primary footer for the PMO settings modals: the compact, filled
 * pair the PMO designs use, rather than ModalShell's outlined SecondaryButton.
 */
const PmoModalActions = ({
  onCancel,
  onConfirm,
  confirmText,
  variant = 'primary',
  disabled = false,
  isLoading = false,
}: PmoModalActionsProps) => (
  <>
    <button
      type="button"
      onClick={onCancel}
      disabled={isLoading}
      className="rounded-lg border border-primary-subtle bg-primary-variant px-4 py-2 text-sm text-neutral transition-colors hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
    >
      Cancel
    </button>
    {variant === 'danger' ? (
      <button
        type="button"
        onClick={onConfirm}
        disabled={disabled || isLoading}
        className="rounded-lg bg-red-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600"
      >
        {isLoading ? 'Deleting…' : confirmText}
      </button>
    ) : (
      <LoaderButton
        type="button"
        text={confirmText}
        onClick={onConfirm}
        disabled={disabled}
        isLoading={isLoading}
        className="!mt-0 !w-auto !px-6 !py-2 font-medium"
      />
    )}
  </>
);

export default PmoModalActions;
